class ScMoreLess extends HTMLElement {
  constructor() {
    super()
    this.trigger = this.querySelector('.js-more-less-trigger')
    this.content = this.querySelector('.js-more-less-content')
    this.strings = {
      show_more: this.trigger.dataset.more ?? 'More',
      show_less: this.trigger.dataset.less ?? "Less"
    }

    this.content.scrollHeight > this.content.clientHeight &&
      this.trigger.classList.remove('hidden')

    this.trigger.addEventListener('click', () => {
      this.content.classList.toggle('is-active')
      if (this.content.classList.contains('is-active')) {
        this.content.style.maxHeight = this.content.scrollHeight + 'px'
        this.trigger.firstElementChild.textContent = this.strings.show_less
        this.trigger.ariaLabel = this.strings.show_less
      } else {
        this.trigger.firstElementChild.textContent = this.strings.show_more
        this.trigger.ariaLabel = this.strings.show_more

        this.content.style.maxHeight = ''
        this.content.scrollTop = 0 
      }
    })
  }
}

customElements.define('sc-more-less-component', ScMoreLess)